export default ({ request }) => ({
  materialInfoListApi(data = {}) {
    return request({
      url: '/master/material/info/list',
      method: 'post',
      data,
    })
  },
  materialInfoDetailApi(data = {}) {
    return request({
      url: '/master/material/info/detail',
      method: 'post',
      data,
    })
  },
  masterFabricListApi(data = {}) {
    return request({
      url: '/master/fabric/list',
      method: 'post',
      data
    })
  },
  masterFabricAttributesSelectApi(data = {}) {
    return request({
      url: '/master/fabric/attributes/attributesSelect',
      method: 'post',
      data
    })
  }
})
